import { useItemStore } from '@/features/common/stores/itemStore';
import { STORE_ID_TYPES } from '@/constants';

export const useIssueCommentStore = useItemStore(STORE_ID_TYPES.ISSUE_DETAILS);

export const useIssueStore = useItemStore(STORE_ID_TYPES.ISSUE_CARD);
